/* eslint-disable max-len */
import React, { type SVGProps } from 'react';

const ArrowRight: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g transform="translate(-325.000000, -501.000000)">
      <g transform="translate(18.000000, 460.000000)">
        <g transform="translate(0.000000, 26.000000)">
          <g transform="translate(291.000000, 0.000000)">
            <g transform="translate(16.000000, 15.410191)">
              <path d="M7.5937319,0.105468499 C7.68748185,0.0351561662 7.79295035,0 7.91013739,0 C8.02732443,0 8.12107439,0.0351561662 8.19138672,0.105468499 L15.6093378,7.55857573 C15.7030877,7.62888806 15.7499624,7.72263802 15.7499624,7.83982506 C15.7499624,7.9570121 15.7030877,8.05076206 15.6093378,8.12107439 L8.19138672,15.5741816 C8.12107439,15.644494 8.02732443,15.6796501 7.91013739,15.6796501 C7.79295035,15.6796501 7.68748185,15.644494 7.5937319,15.5741816 L7.34763873,15.2929323 C7.2773264,15.22262 7.24217023,15.12887 7.24217023,15.011683 C7.24217023,14.8944959 7.2773264,14.7890274 7.34763873,14.6952775 L13.6405925,8.43747988 L0.421873994,8.43747988 C0.304686952,8.43747988 0.205077457,8.39646418 0.123046582,8.3144333 C0.041015706,8.23240243 0,8.13279293 0,8.01560589 L0,7.66404423 C0,7.54685719 0.041015706,7.44724769 0.123046582,7.36521681 C0.205077457,7.28318594 0.304686952,7.24217023 0.421873994,7.24217023 L13.6405925,7.24217023 L7.34763873,0.984372653 C7.2773264,0.890622698 7.24217023,0.785154199 7.24217023,0.667967157 C7.24217023,0.550780116 7.2773264,0.45703016 7.34763873,0.386717828 L7.5937319,0.105468499 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ArrowRight;
